import React from "react";
import { ANALYTICS_CATEGORY } from "../../../../helpers/constants";
import TrackedLink from "../../../Analytics/TrackedLink";
import "./index.scss";

const Item = ({ text, href, screen: { PNG, WEBP }, title, i }) => (
  <TrackedLink
    classes={`PgESM-G-I PgESM-G-I_i${i + 1}`}
    path={href}
    category={ANALYTICS_CATEGORY.ES}
    action="article"
    target
  >
    <picture>
      <source type="image/webp" srcSet={WEBP} />
      <img src={PNG} className="PgESM-G-I__screen" alt="img" loading="lazy" />
    </picture>
    <p className="PgESM-G-I__title">{title}</p>
    <p className="PgESM-G-I__text">{text}</p>
  </TrackedLink>
);
export default Item;
